import React from "react";
import PropTypes from "prop-types";
//Material imports
import { CopyToClipboard } from "react-copy-to-clipboard";
import { ellipsisText } from "../..";
import Typography from "@mui/material/Typography";
import { Tooltip } from "@mui/material";
import { useNotificationContext } from "@limitless/common/hooks/notification/NotificationContext";
const HoverCopyDetails = ({
  value
}) => {
  const {
    addInfoNotification
  } = useNotificationContext();
  const [copyValue, setCopyValue] = React.useState(value !== null && value !== void 0 ? value : "");
  React.useEffect(() => {
    setCopyValue(value);
  }, [value]);
  const handleClick = copyValue => {
    setCopyValue("Copied");
    setTimeout(() => {
      setCopyValue(copyValue);
    }, 2000);
  };
  return /*#__PURE__*/React.createElement(CopyToClipboard, {
    text: copyValue,
    onCopy: () => {
      addInfoNotification("Value copied to clipboard");
      handleClick(copyValue);
    }
  }, copyValue.length <= 24 ? /*#__PURE__*/React.createElement(Typography, {
    sx: {
      color: theme => copyValue === "Copied" && theme.palette.primary.main
    },
    variant: copyValue === "Copied" ? "subtitle2" : "caption"
  }, copyValue) : /*#__PURE__*/React.createElement(Tooltip, {
    title: copyValue,
    arrow: true,
    placement: "bottom"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, ellipsisText(copyValue, 10))));
};
export default HoverCopyDetails;
HoverCopyDetails.propTypes = {
  value: PropTypes.string
};